module.exports = __webpack_public_path__ + "static/media/qualNet.95931445.png";